package com.essntl.uikit.components.input.message

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun EsInputMessage(
    message: String,
    state: EsInputMessageState = EsInputMessageState.Default,
    modifier: Modifier = Modifier,
) {
    val color = when (state) {
        EsInputMessageState.Error -> MaterialTheme.esColorScheme.textError
        EsInputMessageState.Success -> MaterialTheme.esColorScheme.textSuccess
        EsInputMessageState.Default -> MaterialTheme.esColorScheme.textSecondary
    }

    Text(
        text = message,
        color = color,
        style = MaterialTheme.esTypography.c1Medium11,
        modifier = modifier,
    )
}

enum class EsInputMessageState {
    Error,
    Success,
    Default,
}